import { isBrowser } from './environment';

const isFtrackLoaded = (): boolean => isBrowser() && window.adf !== undefined;

const getFormattedCategories = (categories: Array<{ id: string }>): string => {
    const formattedCategories = [];

    categories.forEach((category) => {
        if (category.id) {
            formattedCategories.push(category.id);
        }
    });

    return `[${formattedCategories.toString()}]`;
};

const TRACK_ID = '2204621';

const TRACKING_POINTS = {
    VIDEO: 'VIDEO',
    TITLE: 'TITLE',
    VIDEO_STARTED: 'VIDEO_STARTED',
    VIDEO_PROGRESS_25_PERCENT: 'VIDEO_PROGRESS_25_PERCENT',
    VIDEO_PROGRESS_50_PERCENT: 'VIDEO_PROGRESS_50_PERCENT',
    VIDEO_PROGRESS_75_PERCENT: 'VIDEO_PROGRESS_75_PERCENT',
    VIDEO_ENDED: 'VIDEO_ENDED',
    PAGE_TRACKING: 'PAGE_TRACKING',
    GENRE_PAGE: 'GENRE_PAGE',
};

type VideoData = {
    categories: Array<{ id: string }>;
    originalProgramTitle: string;
    validTo: string;
    analyticsIdentifiers: {
        viewId: string;
    };
    item: { name: string };
};

export const trackVideoData = (data: Partial<VideoData>): void => {
    if (isFtrackLoaded() && data) {
        const { categories, originalProgramTitle, validTo, analyticsIdentifiers } = data;
        window.adf.track(TRACK_ID, TRACKING_POINTS.VIDEO, {
            sv1: document.URL,
            sv2: `${data.item.name} | SVT Play`,
            sv3: window.navigator.userAgent,
            sv4: window.navigator.userAgent,
            sv5: analyticsIdentifiers.viewId,
            sv6: getFormattedCategories(categories),
            sv7: 'Video',
            sv8: originalProgramTitle,
            sv9: validTo,
            sv10: null,
            sv11: null,
            sv12: null,
        });
    }
};

export const trackTitleData = (data: Partial<VideoData>): void => {
    if (isFtrackLoaded() && data) {
        const { categories, analyticsIdentifiers } = data;
        window.adf.track(TRACK_ID, TRACKING_POINTS.TITLE, {
            sv1: document.URL,
            sv2: `${data.item.name} | SVT Play`,
            sv3: window.navigator.userAgent,
            sv4: window.navigator.userAgent,
            sv5: analyticsIdentifiers.viewId,
            sv6: getFormattedCategories(categories),
            sv7: 'Title',
            sv8: null,
            sv9: null,
            sv10: null,
            sv11: null,
            sv12: null,
        });
    }
};

export const trackVideoStarted = (): void => {
    if (isFtrackLoaded()) {
        window.adf.track(TRACK_ID, TRACKING_POINTS.VIDEO_STARTED, {
            sv1: document.URL,
            sv2: document.title,
            sv3: window.navigator.userAgent,
            sv4: window.navigator.userAgent,
            sv5: null,
            sv6: null,
            sv7: null,
            sv8: null,
            sv9: null,
            sv10: null,
            sv11: 'STARTED',
            sv12: null,
        });
    }
};

export const trackVideoProgress25Percent = (): void => {
    if (isFtrackLoaded()) {
        window.adf.track(TRACK_ID, TRACKING_POINTS.VIDEO_PROGRESS_25_PERCENT, {
            sv1: document.URL,
            sv2: document.title,
            sv3: window.navigator.userAgent,
            sv4: window.navigator.userAgent,
            sv5: null,
            sv6: null,
            sv7: null,
            sv8: null,
            sv9: null,
            sv10: '25% viewed',
            sv11: null,
            sv12: null,
        });
    }
};

export const trackVideoProgress50Percent = (): void => {
    if (isFtrackLoaded()) {
        window.adf.track(TRACK_ID, TRACKING_POINTS.VIDEO_PROGRESS_50_PERCENT, {
            sv1: document.URL,
            sv2: document.title,
            sv3: window.navigator.userAgent,
            sv4: window.navigator.userAgent,
            sv5: null,
            sv6: null,
            sv7: null,
            sv8: null,
            sv9: null,
            sv10: '50% viewed',
            sv11: null,
            sv12: null,
        });
    }
};
export const trackVideoProgress75Percent = (): void => {
    if (isFtrackLoaded()) {
        window.adf.track(TRACK_ID, TRACKING_POINTS.VIDEO_PROGRESS_75_PERCENT, {
            sv1: document.URL,
            sv2: document.title,
            sv3: window.navigator.userAgent,
            sv4: window.navigator.userAgent,
            sv5: null,
            sv6: null,
            sv7: null,
            sv8: null,
            sv9: null,
            sv10: '75% viewed',
            sv11: null,
            sv12: null,
        });
    }
};

export const trackVideoEnded = (): void => {
    if (isFtrackLoaded()) {
        window.adf.track(TRACK_ID, TRACKING_POINTS.VIDEO_ENDED, {
            sv1: document.URL,
            sv2: document.title,
            sv3: window.navigator.userAgent,
            sv4: window.navigator.userAgent,
            sv5: null,
            sv6: null,
            sv7: null,
            sv8: null,
            sv9: null,
            sv10: 'VIDEO ENDED',
            sv11: null,
            sv12: null,
        });
    }
};

export const trackPage = (): void => {
    if (isFtrackLoaded()) {
        window.adf.track(TRACK_ID, TRACKING_POINTS.PAGE_TRACKING, {
            sv1: document.URL,
            sv2: document.title,
            sv3: window.navigator.userAgent,
            sv4: window.navigator.userAgent,
            sv5: null,
            sv6: null,
            sv7: null,
            sv8: null,
            sv9: null,
            sv10: null,
            sv11: null,
            sv12: null,
        });
    }
};

export const trackGenrePage = (genre: string): void => {
    if (isFtrackLoaded()) {
        window.adf.track(TRACK_ID, TRACKING_POINTS.GENRE_PAGE, {
            sv1: document.URL,
            sv2: `${genre} | SVT Play`,
            sv3: window.navigator.userAgent,
            sv4: window.navigator.userAgent,
            sv5: null,
            sv6: genre,
            sv7: null,
            sv8: null,
            sv9: null,
            sv10: null,
            sv11: null,
            sv12: null,
        });
    }
};
